export interface CheckoutMapSettingsVo {
    google_map_api_key: string;
}

export interface CheckoutMapSettingsProps {
    prevSetData: CheckoutMapSettingsItem[];
    resetSettings: () => void;
    disabled: boolean;
}

export interface CheckoutMapSettingsItem {
    ecom_id: number | undefined;
    ecom_setting_id: number | undefined;
    setting_id: number | undefined;
    setting_name: CheckoutMapSettingsItemSettingName;
    value: string;
}

export enum CheckoutMapSettingsItemSettingName {
    GOOGLE_MAP_API_KEY = 'google_map_api_key',
}
